/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action } from "@ember/object";
import { guidFor } from "@ember/object/internals";
import Component from "@glimmer/component";
import { modifier } from "ember-modifier";
import $ from "jquery";

// This component does not use the fui-checkbox modifier from wise-fui-modules
// so we have to import the module here to make sure the JQuery `checkbox` plugin
// in properly installed
import "wise-fui-modules/vendor/checkbox.min.js";
let Checkbox = (_class = class Checkbox extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "updateCheckbox", modifier(this._updateCheckbox));
  }
  get elementId() {
    return guidFor(this);
  }
  _updateCheckbox(element) {
    $(element).checkbox({
      onChange: () => {
        this.args.onChange($(element).checkbox("is checked"));
      }
    });
    if (this.args.disabled || this.args.isReadOnly) {
      $(element).checkbox("set disabled");
    } else {
      $(element).checkbox("set enabled");
    }
    if (this.args.checked) {
      $(element).checkbox("set checked");
    } else {
      $(element).checkbox("set unchecked");
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "_updateCheckbox", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_updateCheckbox"), _class.prototype), _class);
export { Checkbox as default };